import { SET_EMULATOR_OS } from "panel/src/redux/constants";

export const setEmulatorOS = (os: number) => ({
  type: SET_EMULATOR_OS,
  os,
});
